<template>
  <div class="card-list-page">
    <div class="search-content">
      <span>证书编号</span>
      <div class="input-wrapper">
        <van-search v-model="value" placeholder="请输入证书编号，例如：新出发襄襄审字第XXXX号" />
      </div>
    </div>
    <div class="bt_button">
      <div @click="reset" class="reset">
        <span>重置信息</span>
      </div>
      <div @click="toQuery" class="query">
        <span>立即查询</span>
      </div>
    </div>
  </div>
</template>

<script>
import checkAJB from "@/utils/checkAlipayJSBridge.js";
import { request } from "@/utils/request.js";
export default {
  data() {
    return {
      value: "",
    };
  },
  created() {
    checkAJB.setTitle("出版物经营许可证查询");
  },
  methods: {
    reset() {
      this.value = "";
    },
    toQuery() {
      if (!this.value) {
        this.$toast("请输入证书编号");
        return;
      }
      this.$router.push({
        path: "/cardView",
        query: {
          certificateID: this.value,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.card-list-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f8f8f8;
  padding-top: 8px;
  .search-content {
    padding: 14px;
    flex: 1;
    background: #fff;
    span {
      padding-top: 20px;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
    }
    .input-wrapper {
      margin-top: 8px;
      /deep/ .van-search {
        padding: 0;
        border-radius: 2px;
        background: #f8f8f8;
        height: 40px;
      }
      /deep/ .van-search__content {
        background: #f8f8f8;
      }
      /deep/ .van-field__left-icon {
        display: none;
      }
    }
  }
  .bt_button {
    display: flex;
    padding: 40px 14px 20px;
    justify-content: space-between;
    div {
      width: 169px;
      height: 45px;
      border-radius: 6px;
      border: 1px solid #1491eb;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-size: 16px;
        color: #1491eb;
        line-height: 23px;
      }
      &.query {
        background: #1491eb;
        span {
          color: #fff;
        }
      }
    }
  }
}
</style>
